import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { PwaInstallService } from './core/services/config/pwa-install.service';
import { AsyncPipe } from '@angular/common';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NotificationModalComponent } from './shared/components/modal/notification-modal/notification-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, AsyncPipe, NotificationModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'ODONTO ARCO';
  isMobile: boolean = false;
  isTablet: boolean = false;
  isWeb: boolean = false;

  private destroy$ = new Subject<void>(); // Observable de finalización
  pwaInstallService = inject(PwaInstallService);
  isInstallable$ = this.pwaInstallService.installPrompt$;
  isLoading$ = this.pwaInstallService.loading$.pipe(takeUntil(this.destroy$)); // Tomar hasta que se destruya
  constructor(private breakpointObserver: BreakpointObserver) {}
  installPwa(): void {
    this.pwaInstallService.installPwa();
  }

  ngOnInit(): void {
    this.breakpointObserver
      .observe([
        '(max-width: 576px)', // Celular
        // '(min-width: 577px) and (max-width: 768px)', // Tablet
        '(min-width: 577px)', // Escritorio
      ])
      .subscribe((result) => {
        this.isMobile = result.breakpoints['(max-width: 576px)'];
        // this.isTablet =
        //   result.breakpoints['(min-width: 577px) and (max-width: 768px)'];
        this.isWeb = result.breakpoints['(min-width: 577px)'];
        //console.log('que dispositivo es?');
        //console.log('movil: ' + this.isMobile);
        //console.log('tablet: ' + this.isTablet);
        //console.log('Desk: ' + this.isDesktop);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete(); // Completa el observable al destruir el componente
  }
}
